import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import plugins from './plugins/index'

import './styles/normalize.css' // 初始CSS
import './styles/flex.less' // flex 布局
import './styles/display.css' // 媒体查询隐藏显示
import './styles/basics.less' // 媒体查询隐藏显示
import 'swiper/dist/css/swiper.min.css'
// import 'element-ui/lib/theme-chalk/index.css'

import {
  Icon,
  Rate,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Form,
  FormItem,
  Input,
  Checkbox,
  CheckboxGroup,
  Table,
  TableColumn,
  Pagination,
  Popover,
  Button,
  Radio,
  RadioGroup,
  Message,
  Notification,
  Loading,
  DatePicker,
  Dialog,
  Cascader,
  Popconfirm,
  Select,
  Option,
  OptionGroup,
  Autocomplete,
  Upload,
  Image,
  MessageBox,
  Tooltip,
  Backtop,
  InputNumber,
  Carousel,
  CarouselItem,
  Card,
  Steps,
  Step,
  Tabs,
  TabPane
} from 'element-ui'
// Vue.prototype.$ELEMENT = { size: 'small' }
Vue.use(Icon)
Vue.use(Rate)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Button)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(Popconfirm)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Autocomplete)
Vue.use(Upload)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Backtop)
Vue.use(InputNumber)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Card)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tabs)
Vue.use(TabPane)
// Vue.use(CascaderPanel)

Vue.use(Loading.directive)

Vue.use(plugins)
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
